/**
 * When the sidebar's list of sessions on this computer should be read
 * again, told by code that holds no query client and heard by the one hook
 * that holds the list (`useCodeSessions`): the connection, each time
 * `start()` hands it a server, since that ends the failure an earlier list
 * read met, and each time the stream says a session asked the person
 * something or got its answer, or reconnected; and the runtime, when a read
 * or a send finds a session OpenCode no longer has, and when it stages or
 * drops a rewind, since the list says whether an edit waits.
 */
const listeners = new Set<() => void>();

/** Tells the list to read again. */
export function refreshLocalList(): void {
  for (const listener of listeners) {
    listener();
  }
}

/** Listens for `refreshLocalList`; returns the unsubscribe. */
export function onLocalListRefresh(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
